$(document).ready(function(){
  $('.marqueeBox').marquee({
    direction: 'left',
    duration: 40000,
    delayBeforeStart: 0,
    duplicated: true,
    gap: 0,
    startVisible: true
  });

  if ($(window).width() < 1199) {
    $('.logo_list').marquee({
      direction: 'left',
      duration: 60000,
      delayBeforeStart: 0,
      duplicated: true,
      gap: 0,
      startVisible: true
    });
  }


  var slider = $('[js-announcement-slick]')
  if(slider.length) {
    var dataAuto = $('[js-announcement-slick]').data('autoplay')
    console.log('dataAuto', dataAuto)
    if(dataAuto) {
      $('[js-announcement-slick]').slick({
        dots: false,
        arrows: false,
        speed: 300,
        autoplay: true,
        autoplaySpeed: 3000
      })
    } else {
      $('[js-announcement-slick]').slick({
        dots: false,
        arrows: false,
        speed: 300
      })
    }
  }

  $('.coll_slider_desktop').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });
  $('.product-list').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [
      {
        breakpoint: 1250,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });
  $('.product-list-four').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1250,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });

  if ($(window).width() < 992) {
    $('.mobile_slider').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 2,
      slidesToScroll: 2,
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

//   setTimeout(function() { 
//   $('.related_pro_slider').slick({
//     dots: false,
//     arrows: true,
//     infinite: true,
//     speed: 300,
//     slidesToShow: 5,
//     slidesToScroll: 5,
//     responsive: [
//       {
//         breakpoint: 1250,
//         settings: {
//           slidesToShow: 4,
//           slidesToScroll: 4
//         }
//       },
//       {
//         breakpoint: 1025,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 3
//         }
//       },
//       {
//         breakpoint: 641,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 2
//         }
//       }
//     ]
//   });
// },5000);
  $(document).on('click','.quick-add__submit',function(){
     $('body').addClass('quickview');
  });
  $(document).on('click','.quick-add-modal__toggle',function(){
     $('body').removeClass('quickview');
  });
  // $(document).on('click','.boost-sd__modal-backdrop',function(){
  //    $('body').removeClass('quickview');
  // });
  $(document).on('click','button.edit_address_btn',function(e){
    e.preventDefault();
    var address_id = $(this).attr('id');
    
    $('.edit_address').removeClass('active');
    $('.edit_address_form').addClass('hidden');

    $('.edit_address #' + address_id).parent().parent().addClass('active');
    $('.edit_address #' + address_id).removeClass('hidden');
  });
  $(document).on('click','.filter',function(){
    if($(this).hasClass('active')){
      $(this).removeClass('active');
    }else{
      $(this).addClass('active');
    }
  });
  if($(window).width() < 989){
    $(document).on('click','.footer-block__heading',function(){
      if($(this).parent().hasClass('active')){
       $(this).parent().removeClass('active'); 
      }else{
        $(this).parent().addClass('active'); 
      }
    });
  }
  if($(window).width() < 989){
    $(document).on('click','.top_line',function(){
      if($(this).hasClass('active')){
       $(this).removeClass('active'); 
      }else{
        $(this).addClass('active'); 
      }
    });
    $(document).on('click','.top_line h2',function(){
      if($(this).hasClass('active')){
       $(this).removeClass('active'); 
      }
    });
     
  }
  
  
  $(document).on('click','.action_button .vote_btn',function(event){
    event.preventDefault();
    var volt_product_id = $(this).data('id');
    var product_id = volt_product_id.split('vote-');
    $(this).hide();

    $('.volt_popup#'+volt_product_id).show();
    var pass_p = product_id[1];
    $.post('https://katiee10.sg-host.com/vote_details.php',{
        product_id:pass_p
    }).done(function(response){
      $('.'+volt_product_id).parent().find('.vote_count').text(response+' Votes');
      $('.'+volt_product_id).parent().find(".complate_vote").show();     
    });
  });

  $(document).on('change', '[js-nofity-me-variant]', function(event) {
    const email = $(this).siblings('[js-notify-me-email]').val();
    if (email) {
      $(this).siblings('[js-notify-me-btn]').prop('disabled', false);
    }
  })


  $(document).on('input', '[js-notify-me-email]', function(event) {
    const variant = $(this).siblings('select.input_txt').val();

    if ($(this).val() && variant) {
      $(this).siblings('[js-notify-me-btn]').prop('disabled', false);
    }
  })

  //Executed after SWYM has loaded all necessary resources.
  function onSwymLoadCallback(swat) {
    $(document).on('submit','[js-notify-me-form]',function(event){
      event.preventDefault();
      const productId = $(this).data('product-id');
      const url = $(this).data('product-url');
      const image = $(this).data('product-image');
      const price = $(this).data('product-price');
      const email = $(this).find('[js-notify-me-email]').val();
      const variantId = $(this).find('[js-nofity-me-variant]').val();

      // Define the email address you want to subscribe to
      const medium = "email";

      // Product data of the product
      const product = {
        epi: variantId, // unique variant ID of the product.
        empi: productId, // Product ID or master product ID
        du: url, // canonical product url.
        iu: image, // image url for email
        pr: price, // price
        et: 8 // event type 8 stands for registering a "notify me" event.
      }

      let onSuccess = function(response) {
        console.log("Successfully Subscribed the email for the alert.", response);
        $('.popup').hide();
      }
      
      let onError = function(error) {
        console.log("There was an Error while subscribing the email for the alert.", error);
        $('.popup').hide();
      }
      
      // Sample call..
        swat.sendWatchlist(email, medium, product, onSuccess, onError, 1);
    })
    

  }
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(onSwymLoadCallback);

  
  
  $(document).on('click','.volt_popup .close',function(event){
     event.preventDefault();
     $('.popup').hide();
  });
  $('.faq-link-box ul li a').on('click', function(e){
    e.preventDefault();
    var hash = $(this).attr('href');
    $('html, body').animate({
        scrollTop: $(hash).offset().top - 120
    }, 2000);
    
  });
  if($(window).width() < 750){
    $(window).scroll(function() {
      var scroll = $(window).scrollTop() + 300;
      var remain_scroll = $('.product-single__box').offset().top - $(window).scrollTop();
      var another_scroll = $('.product-single__box').offset().top;
      // console.log($('.qnty_block').offset().top); removeComment
      // console.log($(window).scrollTop()); removeComment
      if (scroll <= remain_scroll) { 
        $('.sticky_btn').addClass('show');
      } else if(another_scroll <= scroll ){
        $('.sticky_btn').addClass('show');
      }
      else { 
        $('.sticky_btn').removeClass('show');
      }
    });
  }
  $(document).on('click','.sticky_btn_submit',function(){
    $('.product-form__buttons .cartbutton').trigger('click');
  });
});
  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
    
  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

// setTimeout(function(){
//     animateBar();
//   },1500);
//   function animateBar(){
//     $('.range1 span').css("width", "0%");
//     $('.range2 span').css("width", "0%");
//     $('.range3 span').css("width", "0%");
//     var t = $('.calculation--bar .current').data('total');
//     var s = $('.calculation--bar .current').data('ship');
//     var p = $('.calculation--bar .current').data('reach');
//     var free_pro = $('.calculation--bar .current').data('free');
//     var sc = 100;
//     jQuery.ajax({
//       url:'/cart.js',
//       type:'get',
//       dataType:'json',
//       async:false,
//       success:function(d){
//         //console.log(d.total_price);      
//         p = d.total_price;
//         if(p == 0){
//         $('.top_price').text('$ 0.00');
//         $('.shipping_note').hide();
//         }else{
//           $('.shipping_note').show();
//         }
//       }
//     });
//   var total_price_total = p/100;
//   // if(s > total_price_total){
//   //   var remain_shipping = s - total_price_total;
//   //   var remain_freeproduct = t - total_price_total;
//   //   var final_remain_shipping = remain_shipping.toFixed(2);
//   //   var final_remain_freeproduct = remain_freeproduct.toFixed(2);
//   //   var shipping_canada = sc - total_price_total;
//   //   var freeshipping_canada = shipping_canada.toFixed(2);
//   //   $('.shipping_note_in').empty();
//   //   $('.shipping_note_in').append('<span class="boost_icon"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.5202 10.56C10.5202 10.56 12.4268 8.66669 13.0735 8.00002C15.1202 6.00002 14.1002 1.88002 14.1002 1.88002C14.1002 1.88002 10.0002 0.860023 8.00016 2.90669C6.44016 4.42669 5.42683 5.48002 5.42683 5.48002C5.42683 5.48002 2.86683 4.94669 1.3335 6.48002L9.50016 14.6667C11.0335 13.1134 10.5202 10.56 10.5202 10.56ZM9.52016 4.56002C9.64399 4.43605 9.79105 4.33771 9.95291 4.27061C10.1148 4.20351 10.2883 4.16897 10.4635 4.16897C10.6387 4.16897 10.8122 4.20351 10.9741 4.27061C11.1359 4.33771 11.283 4.43605 11.4068 4.56002C11.5932 4.74655 11.72 4.98413 11.7713 5.24273C11.8226 5.50133 11.7962 5.76935 11.6952 6.01289C11.5942 6.25644 11.4233 6.46459 11.2041 6.61104C10.9849 6.75748 10.7271 6.83564 10.4635 6.83564C10.1999 6.83564 9.94212 6.75748 9.72289 6.61104C9.50366 6.46459 9.33276 6.25644 9.2318 6.01289C9.13084 5.76935 9.10435 5.50133 9.15567 5.24273C9.207 4.98413 9.33384 4.74655 9.52016 4.56002ZM2.00016 14C3.23421 13.9648 4.4156 13.4923 5.3335 12.6667L3.3335 10.6667C2.00016 11.3334 2.00016 14 2.00016 14Z" fill="#01AEF1"/></svg></span>You are <span class="free_product">$'+ final_remain_freeproduct +'</span> away from a FREE GIFT');
//   // }
//   if(t > total_price_total){
//      var remain_freeproduct = t - total_price_total;
//     var final_remain_freeproduct = remain_freeproduct.toFixed(2);
//     //var remain_shipping = t - total_price_total;
//     //var final_remain_shipping = remain_shipping.toFixed(2);
//     //var shipping_canada = sc - total_price_total;
//     //var freeshipping_canada = shipping_canada.toFixed(2);
//     $('.shipping_note_in').empty();
    
//     if(sc > total_price_total){
//         $('.shipping_note_in').append('<span class="boost_icon"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.5202 10.56C10.5202 10.56 12.4268 8.66669 13.0735 8.00002C15.1202 6.00002 14.1002 1.88002 14.1002 1.88002C14.1002 1.88002 10.0002 0.860023 8.00016 2.90669C6.44016 4.42669 5.42683 5.48002 5.42683 5.48002C5.42683 5.48002 2.86683 4.94669 1.3335 6.48002L9.50016 14.6667C11.0335 13.1134 10.5202 10.56 10.5202 10.56ZM9.52016 4.56002C9.64399 4.43605 9.79105 4.33771 9.95291 4.27061C10.1148 4.20351 10.2883 4.16897 10.4635 4.16897C10.6387 4.16897 10.8122 4.20351 10.9741 4.27061C11.1359 4.33771 11.283 4.43605 11.4068 4.56002C11.5932 4.74655 11.72 4.98413 11.7713 5.24273C11.8226 5.50133 11.7962 5.76935 11.6952 6.01289C11.5942 6.25644 11.4233 6.46459 11.2041 6.61104C10.9849 6.75748 10.7271 6.83564 10.4635 6.83564C10.1999 6.83564 9.94212 6.75748 9.72289 6.61104C9.50366 6.46459 9.33276 6.25644 9.2318 6.01289C9.13084 5.76935 9.10435 5.50133 9.15567 5.24273C9.207 4.98413 9.33384 4.74655 9.52016 4.56002ZM2.00016 14C3.23421 13.9648 4.4156 13.4923 5.3335 12.6667L3.3335 10.6667C2.00016 11.3334 2.00016 14 2.00016 14Z" fill="#01AEF1"/></svg></span>Congrats! You get FREE SHIPPING on US and <span class="free_shipping">$'+ freeshipping_canada +'</span> away from FREE SHIPPING on Canada orders & <span class="free_product">$'+ final_remain_shipping +'</span> away from a FREE GIFT'); 
//     }else{
//      $('.shipping_note_in').append('<span class="boost_icon"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.5202 10.56C10.5202 10.56 12.4268 8.66669 13.0735 8.00002C15.1202 6.00002 14.1002 1.88002 14.1002 1.88002C14.1002 1.88002 10.0002 0.860023 8.00016 2.90669C6.44016 4.42669 5.42683 5.48002 5.42683 5.48002C5.42683 5.48002 2.86683 4.94669 1.3335 6.48002L9.50016 14.6667C11.0335 13.1134 10.5202 10.56 10.5202 10.56ZM9.52016 4.56002C9.64399 4.43605 9.79105 4.33771 9.95291 4.27061C10.1148 4.20351 10.2883 4.16897 10.4635 4.16897C10.6387 4.16897 10.8122 4.20351 10.9741 4.27061C11.1359 4.33771 11.283 4.43605 11.4068 4.56002C11.5932 4.74655 11.72 4.98413 11.7713 5.24273C11.8226 5.50133 11.7962 5.76935 11.6952 6.01289C11.5942 6.25644 11.4233 6.46459 11.2041 6.61104C10.9849 6.75748 10.7271 6.83564 10.4635 6.83564C10.1999 6.83564 9.94212 6.75748 9.72289 6.61104C9.50366 6.46459 9.33276 6.25644 9.2318 6.01289C9.13084 5.76935 9.10435 5.50133 9.15567 5.24273C9.207 4.98413 9.33384 4.74655 9.52016 4.56002ZM2.00016 14C3.23421 13.9648 4.4156 13.4923 5.3335 12.6667L3.3335 10.6667C2.00016 11.3334 2.00016 14 2.00016 14Z" fill="#01AEF1"/></svg></span>You are <span class="free_product">$'+ final_remain_freeproduct +'</span> away from a FREE GIFT');
//     }
//   }
//   if(t < total_price_total){
//     $('.shipping_note_in').empty();
//     $('.shipping_note_in').append('<span class="boost_icon"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.5202 10.56C10.5202 10.56 12.4268 8.66669 13.0735 8.00002C15.1202 6.00002 14.1002 1.88002 14.1002 1.88002C14.1002 1.88002 10.0002 0.860023 8.00016 2.90669C6.44016 4.42669 5.42683 5.48002 5.42683 5.48002C5.42683 5.48002 2.86683 4.94669 1.3335 6.48002L9.50016 14.6667C11.0335 13.1134 10.5202 10.56 10.5202 10.56ZM9.52016 4.56002C9.64399 4.43605 9.79105 4.33771 9.95291 4.27061C10.1148 4.20351 10.2883 4.16897 10.4635 4.16897C10.6387 4.16897 10.8122 4.20351 10.9741 4.27061C11.1359 4.33771 11.283 4.43605 11.4068 4.56002C11.5932 4.74655 11.72 4.98413 11.7713 5.24273C11.8226 5.50133 11.7962 5.76935 11.6952 6.01289C11.5942 6.25644 11.4233 6.46459 11.2041 6.61104C10.9849 6.75748 10.7271 6.83564 10.4635 6.83564C10.1999 6.83564 9.94212 6.75748 9.72289 6.61104C9.50366 6.46459 9.33276 6.25644 9.2318 6.01289C9.13084 5.76935 9.10435 5.50133 9.15567 5.24273C9.207 4.98413 9.33384 4.74655 9.52016 4.56002ZM2.00016 14C3.23421 13.9648 4.4156 13.4923 5.3335 12.6667L3.3335 10.6667C2.00016 11.3334 2.00016 14 2.00016 14Z" fill="#01AEF1"/></svg></span>Congrats! You get a FREE GIFT');
//   }
  
//     t = parseInt(t);
//     p = parseInt(p);
//     var ss = t+s;
//     var c = p/t;
//     var sc = p/s;
    
//     var fp = $('.calculation--bar .current').data('total');
//     console.log(sc);
//     console.log(c);
//     $('.point .bull').removeClass('hvr-pop');
//     if(sc <= 100){
//         $('.current .range1 span').css('width', c+'%');
//         $('.point.shipping .bull').addClass('hvr-pop');
//         }else{
//         $('.shipping .bull').addClass('hvr-bounce-in');
//         $('.current .range1 span').css('width', 100+'%');
//         setTimeout(function(){
//             $('.point.shipping .bull').addClass('hvr-pop');
//         }, 300);
//       if(c <= 100){
//         $('.current .range2 span').css('width', c+'%');
//       }else{
//         //$('.gift .bull').addClass('hvr-bounce-in');
//         $('.current .range2 span').css('width', 100+'%');
//         setTimeout(function(){
//           $('.point.gift .bull').addClass('hvr-pop');
//         }, 700)
//         $('.current .range3 span').css('width', 100+'%');
//       }
//     }
//     p = p/100;
    
//     if(c >= s){
     
//       setTimeout(function(){
//         $('.shipping .bull').removeClass('hvr-bounce-in');
//         $('.shipping .bull').addClass('hvr-pop');
//       }, 1000);
//     }
//     if(c >= t){
//       $('.gift .bull').addClass('hvr-bounce-in');
//       setTimeout(function(){
//         $('.gift .bull').removeClass('hvr-bounce-in');
//         $('.gift .bull').addClass('hvr-pop');
//       }, 1000);
//     }
  
//   var d = false;
//   $.getJSON('/cart.js', function(cart) {
//    d = false;
//     $.each(cart.items, function(index, cartItem) {
//       // console.log(cartItem.properties['Free Product']+"=="+'__free-product');
//       if(cartItem.properties['Free Product'] == '__free-product'){
//         d = true;
//       }
//      });
//     //console.log(p);
//     //console.log(t);
//     if(p >= t){
//       if(d == true){
        
//       }else{
  
//           $.ajax({
//           type: 'POST',
//           url: '/cart/add.js',
//           data: {
//           quantity: 1,
//           id: free_pro,
//           properties: { 'Free Product': '__free-product' }
//           },
//           dataType: 'json', 
//           success: function (data) { 
//           console.log(data);
//           document.dispatchEvent(new CustomEvent('theme:cart:change'));
//             setTimeout(function(){
//                 //console.log('dd');
//                // document.getElementById("order_free_gift").checked = true;
//                 //document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
//             }, 2000);
//           } 
//           });
//       }
//     }else{
//       if(d == true){
//         $.ajax({
//           type: 'POST',
//           url: '/cart/change.js',
//           data: {
//           quantity: 0,
//           id: free_pro
//           },
//           dataType: 'json', 
//           success: function (data) { 
//           //  document.getElementById("order_free_gift").checked = false;
//           //document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
//           } 
//           });
//       }
//     }
//   });
// }
// function animateBarOnly(){
// //   console.log('d');
//   var t = $('.calculation--bar .current').data('total');
//   var s = $('.calculation--bar .current').data('ship');
//   var p = $('.calculation--bar .current').data('reach');
//   jQuery.ajax({
//     url:'/cart.js',
//     type:'get',
//     dataType:'json',
//     async:false,
//     success:function(d){
//       //console.log(d.total_price);      
//       p = d.total_price;
//     }
//   });

//   t = parseInt(t);
//   p = parseInt(p);
//   var ss = t+s;
//   var c = p/t;
//   var sc = p/s;
//   console.log(sc);
//   // console.log(c);

//   //console.log(t);
//   //console.log(s);
//   //console.log(p);
//   $('.point .bull').removeClass('hvr-pop');
//   if(sc <= 100){
//     $('.current .range1 span').css('width', c+'%');
//     $('.point.gift .bull').addClass('hvr-pop');
//   }else{
//     //$('.shipping .bull').addClass('hvr-bounce-in');
//     $('.current .range1 span').css('width', 100+'%');
//     setTimeout(function(){
//       $('.point.shipping .bull').addClass('hvr-pop');
//     }, 300);
//     if(c <= 100){
//       $('.current .range2 span').css('width', c+'%');
//     }else{
//       //$('.gift .bull').addClass('hvr-bounce-in');
//       $('.current .range2 span').css('width', 100+'%');
//       setTimeout(function(){
//         $('.point.gift .bull').addClass('hvr-pop');
//       }, 700)
//       $('.current .range3 span').css('width', 100+'%');
//     }
//   }
// } 


// Menu Hover

let items = document.querySelectorAll(".mega-menu");
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      // console.log(item.querySelector(".list-menu--inline")); removeComment
      document.querySelector("ul.list-menu--inline").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  }); 
});

// Account Js
$(document).ready(function(){
   
  $(document).on('click','.reward_box a.check_reward_point', function(e){
    e.preventDefault();
    $('.account-sidebar li').removeClass('active');
    $('[data-tab="#activity"]').parent('li').addClass('active');
    
    $('.account-tabs .account-tab').removeClass('active');
    $('#activity').addClass('active');
    $("html").animate({ scrollTop: 0 }, "slow");
    // location.reload();
  });
  
  $('.subscription-links .tab-link').on('click', function(){
    var tab = $(this).data('tab');
    $('.subscription-links .tab-link').removeClass('active');
    $(this).addClass('active');
    
    $('.subscription-tab-container .tab-content').removeClass('active');
    $('.subscription-tab-container .tab-content#'+tab).addClass('active');
    //$("html").animate({ scrollTop: 0 }, "slow");
  });
  
  var hash = window.location.hash;
  
  //console.log(window.location.href);
  var href= window.location.href;
  var new_href= href.split('/');
 // console.log(new_href);
  if(new_href[4] == 'orders'){
    $('.account-sidebar li').removeClass('active');
    $('[data-tab="#order-history"]').parent('li').addClass('active');
    $('[data-tab="#order-history"]').parent('li').show();
    $('.account-tabs .account-tab').removeClass('active');
    $('.account-tabs .account-tab').removeClass('active');
    $('[data-tab="#order-history"]').removeClass('account-links');
    $('#order-history').addClass('active');
    $('#order-history .order_list').hide();
    $('#order-history .order_history_details').show();
  }
  if(hash != ''){
   // console.log(hash);
    $('.account-sidebar li').removeClass('active');
    $('[data-tab="'+hash+'"]').parent('li').addClass('active');
    
    $('.account-tabs .account-tab').removeClass('active');
    $(hash).addClass('active');
    $('#order-history .order_list').show();
    $('#order-history .order_history_details').hide();
  }
  $('.odr_details a.pink_btn').on('click',function(){
      $('.account-sidebar li').removeClass('active');
      $('[data-tab="#order-history"]').parent('li').addClass('active');
    $('[data-tab="#order-history"]').parent('li').show();
    $('#order-history .order_list').hide();
    $('#order-history .order_history_details').show();
  });

  $('#view-all-container').on('click', function(e){
    e.preventDefault()
    var hash = $('.account-sidebar a.account-links').data('tab');
    if(hash != undefined){
      var url = window.location.href;
      if(url.indexOf('#') != -1){
        var arr = url.split('#');
        window.location.href = arr[0]+hash;
      }else{
        window.location.href = url+hash;
      }
      
      $('.account-sidebar li').removeClass('active');
      $('[data-tab="'+hash+'"]').parent('li').addClass('active');

      $('.account-tabs .account-tab').removeClass('active');
      $(hash).addClass('active');
      $("html").animate({ scrollTop: 0 }, "slow");
      $('#order-history .order_history_details').hide();
    }else{
      var url = window.location.href;
      window.location.href = url.replace(window.location.hash, '');
      
      $('.account-sidebar li').removeClass('active');
      $('.account-sidebar-nav li:first').addClass('active');

      $('.account-tabs .account-tab').removeClass('active');
      $('.account-tabs .account-tab:first').addClass('active');
      $("html").animate({ scrollTop: 0 }, "slow");
      $('#order-history .order_history_details').hide();
    }
  });

  $('.account-sidebar a.account-links').on('click', function(e){
    e.preventDefault();
    var hash = $(this).data('tab');
   // console.log(hash);    
    
    if(hash != undefined){
      var url = window.location.href;
      //console.log(url);
    //  console.log(url.indexOf('#'));
      if(url.indexOf('#') != -1){
        var arr = url.split('#');
        window.location.href = arr[0]+hash;
      }else{
        window.location.href = url+hash;
      }
      
      $('.account-sidebar li').removeClass('active');
      $('[data-tab="'+hash+'"]').parent('li').addClass('active');

      $('.account-tabs .account-tab').removeClass('active');
      $(hash).addClass('active');
      $("html").animate({ scrollTop: 0 }, "slow");
      $('#order-history .order_history_details').hide();
    }else{
      var url = window.location.href;
      window.location.href = url.replace(window.location.hash, '');
      
      $('.account-sidebar li').removeClass('active');
      $('.account-sidebar-nav li:first').addClass('active');

      $('.account-tabs .account-tab').removeClass('active');
      $('.account-tabs .account-tab:first').addClass('active');
      $("html").animate({ scrollTop: 0 }, "slow");
      $('#order-history .order_history_details').hide();
    }
  });

  $(document).on('click','.address_edit_btn',function(){
    var form_id = $(this).attr('aria-controls');
    //console.log(form_id);
    if($('.adress_form_block .edit_address').hasClass('active')){
     $('.adress_form_block .edit_address').removeClass('active'); 
    }else{
     $('.adress_form_block #'+form_id).addClass('active'); 
    }
  });
  $(document).on('click','.add_address_box',function(){
    if($('.adress_form_block #AddAddress').hasClass('active')){
     $('.adress_form_block #AddAddress').removeClass('active'); 
    }else{
     $('.adress_form_block #AddAddress').addClass('active'); 
    }
  });
/* Mega Menu Hover Event*/
  $(document).on('mouseenter','.first_menu_block ul li a',function(){
    var first_id = $(this).data('id');
    $(this).parents('.main_mega_menu').find('.first_menu_block ul li').removeClass('hover');
    $(this).parents('.main_mega_menu').find('.sub_menu_block ul').removeClass('hover');
    $(this).parents('.main_mega_menu').find('.feature_menu_block ul').removeClass('active');
    $(this).parent().addClass('hover');
    if($(this).parents('.main_mega_menu').find('.sub_menu_block ul').hasClass(first_id)){
      $(this).parents('.main_mega_menu').find('.sub_menu_block').removeClass('not_available');
    }else{
      $(this).parents('.main_mega_menu').find('.sub_menu_block').addClass('not_available');
    }
    $(this).parents('.main_mega_menu').find('.feature_menu_block ul.'+first_id+' li').removeClass("hover");
    $(this).parents('.main_mega_menu').find('.sub_menu_block ul.'+first_id+'').addClass('hover');
    $(this).parents('.main_mega_menu').find('.feature_menu_block ul.'+first_id+'').addClass('active');
    $(this).parents('.main_mega_menu').find('.feature_menu_block ul.'+first_id+' li:first-child').addClass("hover");
  });
  $(document).on('mouseenter','.sub_menu_block ul li a',function(){
    var sub_id = $(this).data('id');
    var sub_prev_id = $(this).data('prev');
    $(this).parents('.main_mega_menu').find('.sub_menu_block ul.'+sub_prev_id+' li').removeClass('hover');
    $(this).parents('.main_mega_menu').find('.feature_menu_block ul li').removeClass('hover');
    $(this).parents('.main_mega_menu').find('.feature_menu_block .feature_menu_image.'+sub_id).parent().addClass('hover');
  });
});

const collectionReadMoreButton = document.querySelector("[data-collection-description-read-more]");
if (collectionReadMoreButton) {
  collectionReadMoreButton.addEventListener("click", function(event) {
    const collectionDescription = document.querySelector("[data-collection-description]");
    const longClassName = "collection-hero__description--long";
    if (collectionDescription.classList.contains(longClassName)) {
      collectionReadMoreButton.textContent = "Read less...";
      collectionDescription.classList.remove(longClassName);
    } else {
      collectionReadMoreButton.textContent = "Read more...";
      collectionDescription.classList.add(longClassName);
    }
  })
}